import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project-imports
//import { APP_DEFAULT_PATH } from 'config';
import CompanyUseAuth from 'hooks/useCompanyAuth';

// ==============================|| GUEST GUARD ||============================== //

const CompanyGuard = ({ children }) => {
  const { isLoggedIn } = CompanyUseAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(location?.state?.from ? location?.state?.from : 'company/dashboard', {
        state: {
          from: ''
        },
        replace: true
      });
      window.location.reload();
    }
  }, [isLoggedIn, navigate, location]);

  return children;
};

CompanyGuard.propTypes = {
  children: PropTypes.node
};

export default CompanyGuard;
